import Card from "react-bootstrap/cjs/Card";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import PropTypes from 'prop-types';
import dayjs from "dayjs";
import NbioApi from "../../lib/api/NbioApi";
import mpLogo from '../../assets/mercado-pago.png';
import Col from "react-bootstrap/Col";
import {money} from "../../lib/money/money";
/**
 * Displays Order's OpenPay status
 *
 * @author América Mendoza  <amendoza@nodeport.mx>
 * @author Darién Miranda <dmiranda@nodeport.mx>
 * @author Oscar Peña <opena@nodeport.mx>
 */
class OPStatus extends React.Component{
    constructor(s) {
        super(s);
        this.state = {
            openPayStatus:{
                status:''
            },
            isLoadingStripe:false
        }
        this.load = this.load.bind(this);
    }
    componentDidMount() {
        this.load();
    }
    load(){
        NbioApi.orders.getOrderStatusOpenPay(this.props.orderId).then((res) =>{
            this.setState({openPayStatus:res.data.paymentIntent});
        }).catch((ex) =>{

        })
    }
    render() {
        let last4 = '';
        let network = 'credit-card';
        let createdDate = null;
        let link = `https://dashboard.openpay.mx`;
        try{
           createdDate = this.state.openPayStatus?.creation_date;
           last4 =  this.state.openPayStatus?.card?.card_number?.slice(-4);
           network = this.state.openPayStatus?.card?.brand;
        }catch (e) {

        }
        return (
            <Col>
                <Card>
                    <Card.Body>
                        <Card.Title>
                            <div className={'d-flex align-items-center'}>
                                <img src={"https://images.openpay.mx/logo_new.png"} height={30}/>
                                <span className={'ml-1'}>
                                </span>
                            </div>

                        </Card.Title>
                        <div className={'stripe-data d-flex flex-row'}>
                            <div className={'element'}>
                                <div>
                                    <div className={'label'}>Fecha</div>
                                    <div>{this.parseDate(createdDate)}</div>
                                </div>
                                <div className={'separator'}>
                                </div>
                            </div>
                            <div className={'element'}>
                                <div>
                                    <div className={'label'}>Método de pago</div>
                                    <div className={'d-flex justify-content-around align-items-center'}>
                                        <FontAwesomeIcon icon={['fab',`cc-${network}`]}></FontAwesomeIcon>
                                        <div>
                                            &nbsp;••••&nbsp;
                                        </div>
                                        <div>
                                            {last4}
                                        </div>
                                    </div>
                                </div>
                                <div className={'separator'}>
                                </div>
                            </div>
                            <div className={'element'}>
                                <div>
                                    <div className={'label'}>Estado</div>
                                    <div className={this.state?.openPayStatus?.status === 'completed' ? 'text-success' : ''}>
                                        {this.parseStatus(this.state?.openPayStatus?.status)}
                                    </div>
                                </div>
                                <div className={'separator'}>
                                </div>
                                <div>
                                    <div className={'label'}>Comisiones</div>
                                        {money(this.state?.openPayStatus?.fee?.amount || 0)}
                                </div>
                            </div>
                        </div>
                        <div  className={'mt-2'}>
                            <a href={link} target={'_blank'}>
                                Ver en Openpay <FontAwesomeIcon icon={'arrow-right'}></FontAwesomeIcon>
                            </a>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        );
    }
    parseStatus(status){
        if(status === 'completed'){
            return 'Aprobado';
        }else if(status === 'cancelled'){
            return 'Rechazado';
        }else if(status === 'failed'){
            return 'Fallido';
        }else if(status === 'in_progress'){
            return 'En proceso';
        }else{
            return status;
        }
    }
    parseDate(createdDate) {
        if(!createdDate){
            return '-'
        }else{
            return dayjs(createdDate).format('DD-MM-YYYY HH:mm')
        }
    }
}
export default OPStatus;
OPStatus.propTypes = {
    /*Order ID*/
    OrderId: PropTypes.string
}
OPStatus.defaultProps = {
    orderId: ''
}
